export default {"src":"/statics/ecommerce/_next/static/media/logo-smart-change.f84e9114.svg","height":32,"width":213,"blurWidth":0,"blurHeight":0};